export default __webpack_public_path__ + "static/media/tab03-m_title02.5f4f749b.png";